import dynamic from 'next/dynamic';
import { HeaderBanner } from './nav/banner';
import { NavBar } from './nav/navbar';
const Footer = dynamic(() => import('./nav/footer').then(m => m.Footer));

export function DefaultLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <HeaderBanner />
      <NavBar />
      {children}
      <Footer />
    </>
  );
}
